// extracted by mini-css-extract-plugin
export default {"heading":"ExpoCard_heading__VCZ0N","expo":"ExpoCard_expo__mIA4P","expo_card":"ExpoCard_expo_card__GOSXz","disabled":"ExpoCard_disabled__ysqBe"};